import * as Factory from 'factory.ts'
import faker from 'faker'

import { TaxTypes } from '@webapp/models/enums/Tax'
import { type OrderItemTax, type Tax } from '../../models'

export const TaxMock = Factory.Sync.makeFactory<Tax>({
  id: Factory.each(() => faker.random.number()),
  description: Factory.each(() => faker.finance.currencyCode()),
  is_active: true,
  is_default: false,
  is_inclusive: false,
  name: Factory.each(() => faker.finance.currencyCode()),
  percentage: '0.08',
})

export const OrderItemTaxMock = Factory.Sync.makeFactory<OrderItemTax>({
  name: Factory.each(() => faker.finance.currencyCode()),
  type: TaxTypes.PERCENT,
  value: Factory.each(() =>
    (Number(faker.finance.amount(1, 20)) / 100).toString()
  ),
})
